/* Dastoor theme — lightweight interactions */
(function () {
  'use strict';

  // Mobile menu toggle
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-menu]');
      if (nav) nav.classList.toggle('is-open');
    }
  });

  // Product page: thumbnail -> main image swap
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var main = document.getElementById('ProductMainImage');
      if (main) main.src = thumb.getAttribute('data-thumb');
    }
  });

  // Product page: sync visible swatches to hidden variant <select>
  var form = document.getElementById('ProductForm');
  if (form) {
    var select = document.getElementById('ProductVariantSelect');
    function currentOptions() {
      return Array.prototype.map.call(
        form.querySelectorAll('input[type=radio]:checked'),
        function (i) { return i.value; }
      );
    }
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[type=radio]') || !select) return;
      var chosen = currentOptions().join(' / ');
      Array.prototype.forEach.call(select.options, function (opt) {
        if (opt.text.indexOf(chosen) === 0) select.value = opt.value;
      });
    });
  }
})();
